// src/components/RootProviders.js
import React from "react";
import { ThemeProvider } from "theme-ui";
import theme from "../gatsby-plugin-theme-ui";
import { NavigationProvider } from "../context/NavigationContext";
// import { CountyProvider } from "../components/CountyContext";
import { CountyProvider } from "./CountyContext";
import { DataProvider } from "../context/DataContext";
import { SeasonProvider } from "../context/SeasonContext";
import { AlertsProvider } from "../context/AlertsContext";
import { WeatherProvider } from "../context/WeatherContext";
import {
  ChecklistDefaultsProvider,
  useChecklistDefaults,
} from "../context/ChecklistDefaultsContext";
import { HazardSelectionProvider } from "../context/HazardSelectionContext";
import GlobalHighlightStyles from "../styles/GlobalHighlightStyles";
import { useStaticQuery, graphql } from "gatsby";
import WeatherThemeBridge from "../components/WeatherThemeBridge";
import WildfireAlertsProvider from "../components/WildfireAlertsProvider";

const WeatherWithDefaults = ({ children }) => {
  const { defaultHazard, defaultAlertType } = useChecklistDefaults();

  return (
    <WeatherProvider
      initialWeather={defaultHazard}
      initialAlertType={defaultAlertType}
    >
      <HazardSelectionProvider>
        <WeatherThemeBridge />
        {children}
      </HazardSelectionProvider>
    </WeatherProvider>
  );
};

const RootProviders = ({ children }) => {
  const data = useStaticQuery(graphql`
    query RootCountyMappingForAlerts {
      allNwsCountyCodesCsv {
        nodes {
          nws_county_code
          county
          center_lat
          center_long
        }
      }
    }
  `);

  const countyMapping = data.allNwsCountyCodesCsv.nodes;

  return (
    <NavigationProvider>
      <ThemeProvider theme={theme}>
        <GlobalHighlightStyles />
        <CountyProvider>
          <DataProvider shouldFetchData={true}>
            <SeasonProvider>
              <AlertsProvider countyMapping={countyMapping}>
                <WildfireAlertsProvider bufferMiles={25} />
                <ChecklistDefaultsProvider>
                  <WeatherWithDefaults>{children}</WeatherWithDefaults>
                </ChecklistDefaultsProvider>
              </AlertsProvider>
            </SeasonProvider>
          </DataProvider>
        </CountyProvider>
      </ThemeProvider>
    </NavigationProvider>
  );
};

export default RootProviders;